import React from 'react';
import { Grid } from '@mui/material';
import ProductCard from './building_blocks/ProductCard';

const ShopProductList = ({
  products,
  shoppingCartProducts,
  handleAddProduct,
  changeCartQuantity,
}) => {
  return (
    <Grid container spacing={2}
      sx={{
        mt: 3,
        p: 2,
        pb: shoppingCartProducts.length > 0 ? '118px' : 2,
        width: '100%',
      }}
    >
      {products.map((product, index) => (
        <Grid item
          xs={6} sm={4} md={3}
          key={product.id}
        >
          <ProductCard
            variant="gray"
            detailMode="description"
            product={product}
            productIndex={index}
            showCartControls
            shoppingCartProducts={shoppingCartProducts}
            onAdd={() => handleAddProduct(product, index)}
            onIncrement={() => changeCartQuantity(product.id, '+')}
            onDecrement={() => changeCartQuantity(product.id, '-')}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ShopProductList;
